import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

export default function AnnualCatchReportChart({ annualCatchReportData }: any) {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstance = useRef<Chart | null>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    // Destroy existing chart instance to prevent duplicates
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const catchData = annualCatchReportData ?? [];

    chartInstance.current = new Chart(chartRef.current, {
      type: "bar",
      data: {
        labels: catchData.map((row: any) => row["Year"]),
        datasets: [
          {
            label: "Converted weight by year",
            data: catchData.map(
              (row: any) => row["Converted Weight"]
            ),
          },
        ],
      },
      options: {
        scales: {
          x: {
            reverse: true,
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                const index = context.dataIndex;
                const row = catchData[index];
                const weight = row["Converted Weight"];
                const records = row["Records"];
                const round = row["Reported Round"];
                const discard = row["Reported Discard"];
                const dressed = row["Reported Dressed"];
                const fillet = row["Reported Fillet"];

                const lines = [
                  `Converted: ${weight != null ? weight.toLocaleString("en-US") + " lbs" : "N/A"}`,
                  `Round: ${round != null ? round.toLocaleString("en-US") + " lbs" : "N/A"}`,
                  `Dressed: ${dressed != null ? dressed.toLocaleString("en-US") + " lbs" : "N/A"}`,
                  `Fillet: ${fillet != null ? fillet.toLocaleString("en-US") + " lbs" : "N/A"}`,
                  `Discard: ${discard != null ? discard.toLocaleString("en-US") + " lbs" : "N/A"}`,
                  `Records: ${records != null ? records.toLocaleString("en-US") : "N/A"}`,
                ].filter((line): line is string => typeof line === "string");

                return lines;
              },
            },
          },
        },
      },
    });
  }, [annualCatchReportData]);

  return <canvas id="report-chart" ref={chartRef} />;
}
